import {Component} from '@angular/core';

/** Grey bar with the date between the rows of a time based list. */
@Component({
    selector: 'app-day-group',
    templateUrl: './day-group.component.html',
    styles: `
        :host {
            display: flex;
            align-items: center;
            gap: 8px;
            min-width: var(--ui-row-min-width, 0);
            padding: 8px 20px;
            background: #f7f8f9;
            border-bottom: 1px solid #eef0f2;
            font-size: 12px;
            font-weight: 600;
            color: #6b7280;
        }
    `,
    host: {
        'role': 'rowgroup'
    }
})
export class DayGroupComponent {
}
